export const SELECT_STATUS_KERJASAMA = "@statusKerjasama/SELECT_USER";

export const INITIALIZE_CREATE_STATUS_KERJASAMA = "@statusKerjasama/INITIALIZE_CREATE_STATUS_KERJASAMA";

export const UPDATE_NAME = "@statusKerjasama/UPDATE_NAME";
export const UPDATE_STATUS = "@statusKerjasama/UPDATE_STATUS";

export const GET_STATUS_KERJASAMA_REQUEST = "@statusKerjasama/GET_STATUS_KERJASAMA_REQUEST";
export const GET_STATUS_KERJASAMA_SUCCESS = "@statusKerjasama/GET_STATUS_KERJASAMA_SUCCESS";
export const GET_STATUS_KERJASAMA_FAILURE = "@statusKerjasama/GET_STATUS_KERJASAMA_FAILURE";

export const GET_DETAIL_STATUS_KERJASAMA_REQUEST = "@statusKerjasama/GET_DETAIL_STATUS_KERJASAMA_REQUEST";
export const GET_DETAIL_STATUS_KERJASAMA_SUCCESS = "@statusKerjasama/GET_DETAIL_STATUS_KERJASAMA_SUCCESS";
export const GET_DETAIL_STATUS_KERJASAMA_FAILURE = "@statusKerjasama/GET_DETAIL_STATUS_KERJASAMA_FAILURE";

export const UPDATE_STATUS_KERJASAMA_REQUEST = "@statusKerjasama/UPDATE_STATUS_KERJASAMA_REQUEST";
export const UPDATE_STATUS_KERJASAMA_SUCCESS = "@statusKerjasama/UPDATE_STATUS_KERJASAMA_SUCCESS";
export const UPDATE_STATUS_KERJASAMA_FAILURE = "@statusKerjasama/UPDATE_STATUS_KERJASAMA_FAILURE";

export const CREATE_STATUS_KERJASAMA_REQUEST = "@statusKerjasama/CREATE_STATUS_KERJASAMA_REQUEST";
export const CREATE_STATUS_KERJASAMA_SUCCESS = "@statusKerjasama/CREATE_STATUS_KERJASAMA_SUCCESS";
export const CREATE_STATUS_KERJASAMA_FAILURE = "@statusKerjasama/CREATE_STATUS_KERJASAMA_FAILURE";